import type { Module } from 'vuex';
import { Country } from '@/types/Country';
import {RootState} from "@/store";

export interface CountryState {
  country: Country | null;
  deleted: boolean;
}

const countryModule: Module<CountryState, RootState> = {
  namespaced: true,
  state: (): CountryState => ({
    country: null,
    deleted: false,
  }),
  mutations: {
    setCountry(state, payload: any) {
      if (payload === null) {
        state.country = null;
        state.deleted = false;
        return;
      }
      state.country = Country.fromRaw(payload);
      state.deleted = false;
    },
    setCountryUpdate(state, payload: any) {
      if (!state.country || state.country.idCountry !== payload.idCountry) return;
      if (payload.code !== undefined) state.country.code = payload.code;
      if (payload.currencySymbol !== undefined) state.country.currencySymbol = payload.currencySymbol;
      if (payload.idLocaleDefault !== undefined) state.country.idLocaleDefault = payload.idLocaleDefault;
      if (payload.locked !== undefined) state.country.locked = payload.locked;
    },
    setCountryDelete(state, payload: { idCountry: number }) {
      if (state.country?.idCountry === payload.idCountry) {
        state.deleted = true;
      }
    },
    setCountryLock(state, payload: { idCountry: number }) {
      if (state.country?.idCountry === payload.idCountry) {
        state.country.locked = true;
      }
    },
    setCountryUnlock(state, payload: { idCountry: number }) {
      if (state.country?.idCountry === payload.idCountry) {
        state.country.locked = false;
      }
    },
    clearCountry(state) {
      state.country = null;
      state.deleted = false;
    },
  },
  actions: {
    wsSetCountry({ commit }, payload) {
      commit('setCountry', payload);
    },
    wsSetEmptyCountry({ commit }) {
      commit('setCountry', null);
    },
    wsCountryUpdate({ commit }, payload) {
      commit('setCountryUpdate', payload);
    },
    wsCountryDelete({ commit }, payload) {
      commit('setCountryDelete', payload);
    },
    wsCountryLock({ commit }, payload) {
      commit('setCountryLock', payload);
    },
    wsCountryUnlock({ commit }, payload) {
      commit('setCountryUnlock', payload);
    },
    clearCountry({ commit }) {
      commit('clearCountry');
    },
  },
};

export default countryModule;